import {
  createRecProductVideoComponents,
  RecProduct,
  RecProductProps,
} from '@pro-page-components/rec-product';
import { useChildrenVisibilityEditor } from '@pro-page-components/utils/useChildrenVisibility';
import { useRestrictComponentByRegion } from '@pro-page-components/utils/useRestrictComponentByRegion';
import * as React from 'react';
import { ComponentForEditor } from 'react-page-editor/state';

import config from './config.json';
import defaultProps from './defaultProps.json';

const { Video, VideoEditor } = createRecProductVideoComponents({
  name: 'REC Twin Peak 4 Black Video',
  id: 'REC_TWIN_PEAK_4_BLACK_VIDEO',
  path: '.....',
  parent: config.id,
});

export const RecTwinPeak4BlackSeries: ComponentForEditor<RecProductProps> = (
  props: RecProductProps,
) => {
  const restrict = useRestrictComponentByRegion(config);
  if (restrict) return null;
  return <RecProduct VideoComponent={Video} {...props} />;
};

export const RecTwinPeak4BlackSeriesEditor: ComponentForEditor<RecProductProps> = (
  props: RecProductProps,
) => {
  // eslint-disable-next-line no-underscore-dangle,react/destructuring-assignment
  const visible = useChildrenVisibilityEditor(props.__config);
  if (!visible) return null;
  return (
    <RecTwinPeak4BlackSeries
      scale={0.9}
      VideoComponent={VideoEditor}
      skipVisibilityCheck
      {...props}
    />
  );
};

RecTwinPeak4BlackSeries.defaultProps = defaultProps as RecProductProps;
RecTwinPeak4BlackSeries.config = config;
RecTwinPeak4BlackSeriesEditor.defaultProps = defaultProps as RecProductProps;
RecTwinPeak4BlackSeriesEditor.config = config;
RecTwinPeak4BlackSeries.children = [Video];
RecTwinPeak4BlackSeriesEditor.children = [VideoEditor];
